module.exports = __webpack_public_path__ + "static/media/esahyogiwhite.64215551.svg";